import {SwiperImpl as Swiper} from '@/app/js/swiper/swiper'

const VOUCHER_CAROUSEL_SELECTOR = '.js-voucher-carousel'
const VOUCHER_THUMBS_CAROUSEL_SELECTOR = '.js-voucher-thumbs-carousel'
const VOUCHER_ARROW_PREV_SELECTOR = '.js-voucher-thumbs-arrow-prev'
const VOUCHER_ARROW_NEXT_SELECTOR = '.js-voucher-thumbs-arrow-next'
const SWIPER_SELECTOR = '.swiper'
const carouselElement = document.querySelector(VOUCHER_CAROUSEL_SELECTOR)
const thumbsCarouselElement = document.querySelector(VOUCHER_THUMBS_CAROUSEL_SELECTOR)
const thumbsSwiperElement = thumbsCarouselElement?.querySelector(SWIPER_SELECTOR)
const prevEl = thumbsCarouselElement?.querySelector(VOUCHER_ARROW_PREV_SELECTOR)
const nextEl = thumbsCarouselElement?.querySelector(VOUCHER_ARROW_NEXT_SELECTOR)

export function initVoucherCarousel() {
  if (!carouselElement || !thumbsCarouselElement) return
  const thumbsSwiper = new Swiper(thumbsSwiperElement, {
    breakpoints: {
      426: {
        spaceBetween: 10,
        slidesPerView: 2,
      },
      600: {
        spaceBetween: 10,
        slidesPerView: 3,
      }
    },
    navigation: {
      prevEl,
      nextEl,
    },
  })

  new Swiper(carouselElement, {
    thumbs: {
      swiper: thumbsSwiper
    },
    simulateTouch: false
  })
}
